import React from 'react';
import Queryhero from './Queryhero';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom'
import ContainedButtons from './Header'
import CircularProgress from '@material-ui/core/CircularProgress';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import InfoIcon from '@material-ui/icons/Info';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { searchSeries, getComicsForSeries, searchCharacter, searchTeam, searchStoryArc, getSeriesById } from './comicDataProvider';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, setDoc, collection, onSnapshot, getDocs } from 'firebase/firestore';
import { auth, firestore, AuthDiv } from './firebase';
import ComicSeries from './ComicSeries'
import Comics from './Comics'
import QuickEntry from './QuickEntry'
import MissingIssues from './MissingIssues'
import HeroSelectionDialog from './HeroSelectionDialog'
import SeriesSelectionDialog from './SeriesSelectionDialog'
import { isComicOwned, createOwnershipRecord, filterOutOwnedComic, isSameComic } from './utils'
import {
  addHeroToFirebase,
  updateHeroInFirebase,
  deleteHeroFromFirebase,
  mergeHeroData
} from './services/heroService';
import { deleteSeriesFromFirebase, saveComicsToFirebase, updateSeriesInFirebase, findSeriesByComicVineId, formatSeriesTitle, sanitizeSeriesTitle } from './services/seriesService';
import { updateComicOwnership } from './services/comicsService';
import { loadGapIssuesForUser } from './services/gapIssuesService';
import NewReleases from './NewReleases';

class App extends React.Component {
  state = {
    currentCard: null,
    currentSeries: null,
    currentComic: null,
    cards: [],
    series: [],
    comics: [],
    comicsIGot: [],
    gapIssues: [],
    editMode: false,
    stuffHappening: false,
    addEnabled: true,
    appuser: null,
    comicVineMatchDialog: {
      open: false,
      results: [],
      originalHero: null
    },
    resourceTypeDialog: {
      open: false,
      hero: null
    },
    noResultsSnackbar: {
      open: false,
      name: ''
    },
    seriesMatchDialog: {
      open: false,
      results: [],
      originalSeries: null,
      searchTitle: '',
      hasMore: false,
      totalResults: 0,
      currentOffset: 0,
      mode: 'addComics',
      seriesSearchHero: null,
      seriesStartYear: null
    },
    duplicateSeriesDialog: {
      open: false,
      existingSeries: null,
      newSeries: null,
      hero: null,
      originalSeriesId: null
    },
    // seriesButton: false,
    // comicsButton:false
    newReleasesCache: null, // persisted New Releases results
  };

  componentDidMount() {
    // Set up the authentication state listener
    this.unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user && !this.state.appuser) {
        // User is signed in.
        this.setUser(user);
      } else if (!user && this.state.appuser) {
        // User is signed out.
        this.setState({ appuser: null });
      }
    });
  }

  componentWillUnmount() {
    // Clean up the authentication listener
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  setProgress = (bool) => {
    this.setState({ stuffHappening: { bool } });
  };

  // Helper method to show no results snackbar
  showNoResultsSnackbar = (name) => {
    this.setState({
      noResultsSnackbar: {
        open: true,
        name: name
      }
    });
  };

  // Helper method to close no results snackbar
  closeNoResultsSnackbar = () => {
    this.setState({
      noResultsSnackbar: {
        open: false,
        name: ''
      }
    });
  };

  addNewCard = async (cardInfo) => {
    const promises = cardInfo.map(hero =>
      addHeroToFirebase(hero, this.state.appuser.email)
        .then(enhancedHero => {
          this.setState(prevState => ({
            cards: prevState.cards.concat(enhancedHero)
          }));
        })
    );

    await Promise.all(promises);
  };

  handleComicVineMatchSelect = async (selectedHero) => {
    const { originalHero } = this.state.comicVineMatchDialog;
    const mergedHero = mergeHeroData(originalHero, selectedHero);
    if (!mergedHero || !mergedHero.name) {
      console.error('handleComicVineMatchSelect: invalid mergedHero', mergedHero);
      return;
    }

    const userEmail = this.state.appuser?.email;
    if (!userEmail) {
      console.error('handleComicVineMatchSelect: no appuser set - cannot update Firestore');
      return;
    }

    try {
      const updatedHero = await updateHeroInFirebase(mergedHero, userEmail);

      // Update in state
      this.setState(prevState => ({
        cards: prevState.cards.map(c => c.name === updatedHero.name ? updatedHero : c)
      }));
    } catch (err) {
      console.error('Error updating hero in Firebase:', err);
      return;
    }

    // Close dialog and proceed to show series
    this.setState({
      comicVineMatchDialog: { open: false, results: [], originalHero: null },
      currentCard: mergedHero,
      comics: [],
      currentComic: null
    });

    // Load series for this hero
    const docRef = collection(firestore, "users/" + this.state.appuser.email + "/heroes/" + mergedHero.name + "/series");
    onSnapshot(docRef, (querySnapshot) => {
      this.setState({
        series: []
      });

      const currentComicsIGot = this.state.comicsIGot;
      const seriesPromises = [];

      querySnapshot.forEach((doc) => {
        const seriesData = doc.data().data;
        const seriesId = seriesData.id;

        const comicsRef = collection(firestore, "users/" + this.state.appuser.email + "/heroes/" + mergedHero.name + "/series/" + sanitizeSeriesTitle(seriesData.title) + "/comics");
        const promise = getDocs(comicsRef).then((comicsSnapshot) => {
          return {
            ...seriesData,
            gotIt: true,
            ownedOfseries: currentComicsIGot.filter(x => x.seriesId === seriesId).length,
            actualAvailable: comicsSnapshot.size
          };
        });

        seriesPromises.push(promise);
      });

      Promise.all(seriesPromises).then((seriesWithCounts) => {
        this.setState(prevState => ({
          series: prevState.series.concat(seriesWithCounts)
        }));
      });
    });
  };

  handleComicVineMatchClose = () => {
    this.setState({
      comicVineMatchDialog: { open: false, results: [], originalHero: null }
    });
  };

  handleResourceTypeSelect = async (resourceType) => {
    const { hero } = this.state.resourceTypeDialog;
    if (!hero || !resourceType) return;

    // Update hero with resourceType
    const updatedHero = {
      ...hero,
      resourceType: resourceType
    };

    try {
      await updateHeroInFirebase(updatedHero, this.state.appuser.email);

      // Update in state
      this.setState(prevState => ({
        cards: prevState.cards.map(c => c.name === updatedHero.name ? updatedHero : c),
        resourceTypeDialog: { open: false, hero: null }
      }));

      // Now trigger the search with the updated hero
      this.setCurrentCard(updatedHero);
    } catch (error) {
      console.error('Error updating hero resourceType:', error);
      this.setState({
        resourceTypeDialog: { open: false, hero: null }
      });
    }
  };

  handleResourceTypeDialogClose = () => {
    this.setState({
      resourceTypeDialog: { open: false, hero: null }
    });
  };

  setCurrentCard = async (card) => {
    if (this.state.editMode) {
      this.deleteHero(card);
    } else {
      // Check if hero has Comic Vine ID, and is not locked (locked heroes skip the Comic Vine lookup)
      if (!card.comicVineId && !card.locked) {
        // Check if resourceType is set, if not prompt user to select
        if (!card.resourceType) {
          this.setState({
            resourceTypeDialog: {
              open: true,
              hero: card
            }
          });
          return; // Don't proceed until resourceType is set
        }

        // Query Comic Vine for a match based on resourceType
        this.setState({ stuffHappening: true });
        try {
          let results = [];

          // Search based on resourceType
          if (card.resourceType === 'team') {
            console.log('Searching for team:', card.name);
            results = await searchTeam(card.name, card.publisher);
          } else if (card.resourceType === 'storyarc') {
            console.log('Searching for story arc:', card.name);
            results = await searchStoryArc(card.name, card.publisher);
          } else {
            // Default to character, with sequential fallback
            results = await searchCharacter(card.name, card.publisher);

            // If no character results, try team
            if (!results || results.length === 0) {
              console.log('No character found, searching teams...');
              results = await searchTeam(card.name, card.publisher);

              if (results && results.length > 0) {
                console.log(`Found ${results.length} team(s) matching "${card.name}"`);
              } else {
                // If no team results, try story arc
                console.log('No team found, searching story arcs...');
                results = await searchStoryArc(card.name, card.publisher);

                if (results && results.length > 0) {
                  console.log(`Found ${results.length} story arc(s) matching "${card.name}"`);
                }
              }
            } else {
              console.log(`Found ${results.length} character(s) matching "${card.name}"`);
            }
          }

          this.setState({ stuffHappening: false });

          if (results && results.length >= 1) {
            // Show dialog to select the right match (even for single result)
            this.setState({
              comicVineMatchDialog: {
                open: true,
                results: results,
                originalHero: card
              }
            });
            return; // Don't proceed to show series yet
          } else {
            // No results found - show snackbar notification
            this.showNoResultsSnackbar(card.name);
          }
          // Continue with existing data
        } catch (error) {
          console.error('Error querying Comic Vine:', error);
          this.setState({ stuffHappening: false });
          // Show snackbar on error too
          this.showNoResultsSnackbar(card.name);
          // Continue with existing data on error
        }
      }

      this.setState({ currentCard: card }
        // this.setState({series: []}),
        //this.addSeries(card.id, card.name)
      );
      this.setState({ comics: [] });
      this.setState({ currentComic: null });

      var docRef = collection(firestore, "users/" + this.state.appuser.email + "/heroes/" + card.name + "/series");
      onSnapshot(docRef, (querySnapshot) => {
        this.setState({
          series: []
        });

        // Capture current comicsIGot state to avoid stale closure issues
        const currentComicsIGot = this.state.comicsIGot;
        const seriesPromises = [];

        querySnapshot.forEach((doc) => {
          const seriesData = doc.data().data;
          const seriesId = seriesData.id;

          // Count the actual non-variant comics stored for this series
          // Note: We store one document per issue number (not per variant), so document count = non-variant count
          const comicsRef = collection(firestore, "users/" + this.state.appuser.email + "/heroes/" + card.name + "/series/" + sanitizeSeriesTitle(seriesData.title) + "/comics");
          const promise = getDocs(comicsRef).then((comicsSnapshot) => {
            return {
              ...seriesData,
              gotIt: true,
              ownedOfseries: currentComicsIGot.filter(x => x.seriesId === seriesId).length,
              actualAvailable: comicsSnapshot.size // Count of non-variant issues
            };
          });

          seriesPromises.push(promise);
        });

        // Wait for all comic counts and add all series in a single state update
        Promise.all(seriesPromises).then((seriesWithCounts) => {
          this.setState(prevState => ({
            series: prevState.series.concat(seriesWithCounts)
          }));
        });
      });

    };


  };
  addSeries = async (hero, name, seriesId, startYear) => {
    this.setState({ stuffHappening: true });
    try {
      if (seriesId) {
        // Fetch directly by Comic Vine volume ID
        const series = await getSeriesById(seriesId);
        this.setState({ stuffHappening: false });
        if (series) {
          this.setState(prevState => ({
            series: prevState.series.concat({ ...series, gotIt: false })
          }));
        } else {
          alert(`No Comic Vine volume found with ID "${seriesId}". Please check the ID and try again.`);
        }
      } else {
        // Search by name; startYear is intentionally not sent to the API because
        // Comic Vine ignores it — it is applied as a client-side filter instead.
        const response = await searchSeries(hero.id, name, null, 0);
        const allResults = response.results || [];
        const hasMore = response.hasMore || false;
        const totalResults = response.totalResults || allResults.length;

        // Apply start year filter client-side
        const filteredResults = startYear
          ? allResults.filter(s => String(s.startYear) === String(startYear))
          : allResults;

        this.setState({ stuffHappening: false });

        // Always open the dialog so the user can load more results with "More Results"
        // (even if start year filtering produced 0 visible results in this batch)
        this.setState({
          seriesMatchDialog: {
            open: true,
            results: filteredResults,
            originalSeries: null,
            searchTitle: name,
            hasMore: hasMore,
            totalResults: totalResults,
            currentOffset: 0,
            mode: 'addSeries',
            seriesSearchHero: hero,
            seriesStartYear: startYear || null
          }
        });
      }
    } catch (error) {
      console.error('Error fetching series:', error);
      this.setState({ stuffHappening: false });
      alert('Error fetching series. Please check your API configuration or try again later.');
    }
  };

  updateSeries = async (series, doSomething) => {
    this.setState({ stuffHappening: true });

    try {
      // For Comic Vine, we need to fetch the series details differently
      // For now, just use the existing series data
      this.setState({
        stuffHappening: false,
        currentSeries: series
      }, doSomething);
    } catch (error) {
      console.error('Error updating series:', error);
      this.setState({ stuffHappening: false });
    }
  };



  deleteHero = async (hero) => {
    if (window.confirm('Are you sure you wish to delete this item?')) {
      try {
        await deleteHeroFromFirebase(hero, this.state.appuser.email);
        console.log("Hero successfully deleted!");
      } catch (error) {
        console.error("Error removing hero: ", error);
      }
    }
  };

  deleteSeries = (card, hero) => {
    if (window.confirm('Are you sure you wish to delete this item?')) {
      deleteSeriesFromFirebase(card, hero, this.state.appuser.email)
        .then(() => {
          console.log("Series successfully deleted!");
        })
        .catch((error) => {
          console.error("Error removing series: ", error);
        });
    }
  };

  setCurrentSeries = (card, hero) => {
    if (this.state.editMode) {
      if (card.gotIt) {
        this.deleteSeries(card, hero);
      } else {
        this.setState({
          series: this.state.series.map(el => (el.id === card.id ? Object.assign({}, el, { gotIt: true }) : el))
        });
        //  this.setState(prevState => ({
        //       series: prevState.series.concat({...card,gotIt:true})
        //   })); 
        this.addAllComics(card);
      }
    } else {
      this.getCurrentSeries(card, hero);
    }

  };

  updateSeriesImage = (newImage) => {
    this.setState(prevState => ({
      currentSeries: {
        ...prevState.currentSeries,
        thumbnail: {
          ...prevState.currentSeries.thumbnail,
          path: newImage
        }
      }
    }))
  };

  updateHeroImage = async (heroName, newImageUrl) => {
    // Update the hero's thumbnail with the custom image URL
    const updatedCards = this.state.cards.map(card => {
      if (card.name === heroName) {
        return {
          ...card,
          thumbnail: {
            ...card.thumbnail,
            path: newImageUrl,
            extension: 'jpg'
          },
          customImage: newImageUrl
        };
      }
      return card;
    });

    this.setState({ cards: updatedCards });

    // Find the updated hero and save to Firebase
    const updatedHero = updatedCards.find(card => card.name === heroName);
    if (updatedHero) {
      await updateHeroInFirebase(updatedHero, this.state.appuser.email);
    }
  };

  updateHero = async (heroName, updates) => {
    // Update the hero with multiple fields
    const updatedCards = this.state.cards.map(card => {
      if (card.name === heroName) {
        const updatedCard = {
          ...card,
          description: updates.description || card.description,
          publisher: updates.publisher || card.publisher,
          resourceType: updates.resourceType || card.resourceType,
          locked: updates.locked !== undefined ? updates.locked : card.locked
        };

        // Update image if provided
        if (updates.customImageUrl) {
          updatedCard.thumbnail = {
            ...card.thumbnail,
            path: updates.customImageUrl,
            extension: 'jpg'
          };
          updatedCard.customImage = updates.customImageUrl;
        }

        return updatedCard;
      }
      return card;
    });

    this.setState({ cards: updatedCards });

    // Find the updated hero and save to Firebase
    const updatedHero = updatedCards.find(card => card.name === heroName);
    if (updatedHero) {
      await updateHeroInFirebase(updatedHero, this.state.appuser.email);
    }
  };

  getCurrentSeries = (card, hero) => {
    this.setState({ currentSeries: card }
      // this.setState({comics: []}),
      // this.addComics(card.id)
    );
    this.setState({ currentComic: null });

    var docRef = collection(firestore, "users/" + this.state.appuser.email + "/heroes/" + hero.name + "/series/" + sanitizeSeriesTitle(card.title) + "/comics");
    onSnapshot(docRef, (querySnapshot) => {


      this.setState({
        comics: []
      });
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        const comicData = doc.data().data;
        this.setState(prevState => ({
          comics: prevState.comics.concat({ ...comicData, gotIt: isComicOwned(comicData, prevState.comicsIGot) })
        }));
      });
    });
    // Removed automatic comic fetching - user must click reload button
  };

  addAllComics = async (series) => {
    // Check if series has Comic Vine ID
    if (!series.comicVineId) {
      // Query Comic Vine to try to match the series using only the title
      // (same behavior as the search box - no startYear filtering)
      this.setState({ stuffHappening: true });
      try {
        const response = await searchSeries(null, series.title);
        const results = response.results || [];
        const hasMore = response.hasMore || false;
        const totalResults = response.totalResults || results.length;

        if (results && results.length > 0) {
          // Show dialog to select the right match or cancel
          // Clear loading state since user will interact with dialog
          this.setState({
            stuffHappening: false,
            seriesMatchDialog: {
              open: true,
              results: results,
              originalSeries: series,
              searchTitle: series.title,
              hasMore: hasMore,
              totalResults: totalResults,
              currentOffset: 0,
              mode: 'addComics',
              seriesSearchHero: null,
              seriesStartYear: null
            }
          });
          return; // Don't proceed to fetch comics yet - wait for user selection
        } else {
          // No results - clear loading state and continue with existing data
          this.setState({ stuffHappening: false });
        }
      } catch (error) {
        console.error('Error querying Comic Vine for series:', error);
        this.setState({ stuffHappening: false });
      }
    }

    const hero = this.state.currentCard;

    // Check for a duplicate comicVineId before fetching and saving comics
    if (series.comicVineId && hero) {
      try {
        const existing = await findSeriesByComicVineId(series.comicVineId, hero.name, this.state.appuser.email);
        if (existing) {
          this.setState({
            duplicateSeriesDialog: {
              open: true,
              existingSeries: existing,
              newSeries: series,
              hero,
              originalSeriesId: null
            }
          });
          return;
        }
      } catch (error) {
        console.error('Error checking for duplicate series:', error);
      }
    }

    this.startAddingComics(series, hero);
  };

  handleSeriesMatchSelect = async (selectedSeries) => {
    const { originalSeries, mode } = this.state.seriesMatchDialog;

    // addSeries mode: simply add the selected series to the hero's list
    if (mode === 'addSeries') {
      this.setState(prevState => ({
        series: prevState.series.concat({ ...selectedSeries, gotIt: false }),
        seriesMatchDialog: {
          open: false,
          results: [],
          originalSeries: null,
          searchTitle: '',
          hasMore: false,
          totalResults: 0,
          currentOffset: 0,
          mode: 'addComics',
          seriesSearchHero: null,
          seriesStartYear: null
        }
      }));
      return;
    }

    // Get the Comic Vine series ID to use for fetching comics
    const comicVineSeriesId = selectedSeries.comicVineId || selectedSeries.id;

    // Skip if there's no Comic Vine ID
    if (!comicVineSeriesId) {
      console.error('No Comic Vine ID found for selected series');
      this.setState({
        seriesMatchDialog: { open: false, results: [], originalSeries: null }
      });
      return;
    }

    // Build formatted title using the start year from Comic Vine
    const startYear = selectedSeries.startYear || originalSeries.startYear;
    const endYear = selectedSeries.endYear || originalSeries.endYear;
    const rawTitle = selectedSeries.title || originalSeries.title;
    const formattedTitle = formatSeriesTitle(rawTitle, startYear);

    // Merge Comic Vine data with existing series
    const mergedSeries = {
      ...originalSeries,
      title: formattedTitle,
      id: comicVineSeriesId,
      comicVineId: comicVineSeriesId,
      comicVineImage: selectedSeries.comicVineImage,
      startYear,
      endYear,
      comics: {
        available: selectedSeries.comics.available || originalSeries.comics.available
      }
    };

    // Close the match dialog
    this.setState({ seriesMatchDialog: { open: false, results: [], originalSeries: null } });

    const hero = this.state.currentCard;

    // Check for a duplicate comicVineId BEFORE saving anything to Firebase
    try {
      const existing = await findSeriesByComicVineId(comicVineSeriesId, hero.name, this.state.appuser.email);
      if (existing) {
        this.setState({
          duplicateSeriesDialog: {
            open: true,
            existingSeries: existing,
            newSeries: mergedSeries,
            hero,
            originalSeriesId: originalSeries.id
          }
        });
        return;
      }
    } catch (error) {
      console.error('Error checking for duplicate series:', error);
    }

    // No duplicate - update state and save
    this.setState(prevState => ({
      series: prevState.series.map(s => s.id === originalSeries.id ? mergedSeries : s),
      currentSeries: mergedSeries
    }));

    await updateSeriesInFirebase(mergedSeries, hero, this.state.appuser.email);
    this.startAddingComics(mergedSeries, hero);
  };

  handleSeriesMatchClose = () => {
    this.setState({
      seriesMatchDialog: {
        open: false,
        results: [],
        originalSeries: null,
        searchTitle: '',
        hasMore: false,
        totalResults: 0,
        currentOffset: 0,
        mode: 'addComics',
        seriesSearchHero: null,
        seriesStartYear: null
      }
    });
  };

  startAddingComics = (series, hero) => {
    this.updateSeries(series, () => {
      const allBooks = series.comics.available;
      const take = 99;
      for (let currentSkip = 0; currentSkip < allBooks; currentSkip = currentSkip + take) {
        this.addComics(this.state.currentSeries, hero, take, currentSkip);
      }
    });
  };

  handleDuplicateSeriesReplace = async () => {
    const { existingSeries, newSeries, hero, originalSeriesId } = this.state.duplicateSeriesDialog;
    this.setState({
      duplicateSeriesDialog: { open: false, existingSeries: null, newSeries: null, hero: null, originalSeriesId: null }
    });
    try {
      await deleteSeriesFromFirebase(existingSeries, hero, this.state.appuser.email);
    } catch (error) {
      console.error('Error deleting existing series for replacement:', error);
    }
    if (originalSeriesId !== null) {
      // From the match-dialog flow: also update state and persist series metadata
      this.setState(prevState => ({
        series: prevState.series.map(s => s.id === originalSeriesId ? newSeries : s),
        currentSeries: newSeries
      }));
      await updateSeriesInFirebase(newSeries, hero, this.state.appuser.email);
    }
    this.startAddingComics(newSeries, hero);
  };

  handleDuplicateSeriesCancel = () => {
    this.setState({
      duplicateSeriesDialog: { open: false, existingSeries: null, newSeries: null, hero: null, originalSeriesId: null }
    });
  };

  handleSeriesMatchLoadMore = async () => {
    const { searchTitle, currentOffset, results, seriesSearchHero, seriesStartYear } = this.state.seriesMatchDialog;
    const newOffset = currentOffset + 100;
    const heroId = seriesSearchHero ? seriesSearchHero.id : null;

    this.setState({ stuffHappening: true });
    try {
      const response = await searchSeries(heroId, searchTitle, null, newOffset);
      const newResults = response.results || [];
      const hasMore = response.hasMore || false;
      const totalResults = response.totalResults || 0;

      // Apply start year filter client-side when in addSeries mode
      const filteredNewResults = seriesStartYear
        ? newResults.filter(s => String(s.startYear) === String(seriesStartYear))
        : newResults;

      this.setState({
        stuffHappening: false,
        seriesMatchDialog: {
          ...this.state.seriesMatchDialog,
          results: [...results, ...filteredNewResults],
          hasMore: hasMore,
          totalResults: totalResults,
          currentOffset: newOffset
        }
      });
    } catch (error) {
      console.error('Error fetching more series:', error);
      this.setState({ stuffHappening: false });
    }
  };

  addComics = async (series, hero, take = 99, skip = 0) => {
    this.setState({ stuffHappening: true });

    try {
      const comics = await getComicsForSeries(series.id, take, skip);

      this.setState(prevState => ({
        comics: comics.map((row) => {
          return { ...row, gotIt: isComicOwned(row, prevState.comicsIGot) }
        })
      }));

      // Save comics using the service
      await saveComicsToFirebase(comics, series, hero, this.state.appuser.email);
    } catch (error) {
      console.error('Error fetching comics:', error);
      alert('Error fetching comics. Please check your API configuration or try again later.');
    } finally {
      this.setState({ stuffHappening: false });
    }
  };

  updateIGotStatus = async (comicOrId, gotIt, seriesId, heroId) => {
    // Handle both new format (comic object) and legacy format (just id)
    const comic = typeof comicOrId === 'object' ? comicOrId : { id: comicOrId };

    // Use the passed seriesId and heroId if available, otherwise use state
    const finalSeriesId = seriesId !== undefined ? seriesId : (this.state.currentSeries ? this.state.currentSeries.id : null);
    const finalHeroId = heroId !== undefined ? heroId : (this.state.currentCard && this.state.currentCard.id ? this.state.currentCard.id : 0);

    // Update UI state using isSameComic for proper ID matching
    this.setState(prevState => ({
      comics: prevState.comics.map(el => (isSameComic(el, comic) ? Object.assign({}, el, { gotIt }) : el))
    }));

    await updateComicOwnership(comic, gotIt, this.state.appuser.email, finalSeriesId, finalHeroId);
  }

  setCurrentComic = (card) => {
    if (this.state.editMode) {
      if (isComicOwned(card, this.state.comicsIGot)) {
        this.setState(prevState => (
          { comicsIGot: filterOutOwnedComic(prevState.comicsIGot, card) }
        ), this.updateIGotStatus(card, !card.gotIt));
      } else {
        this.setState(prevState => (
          { comicsIGot: prevState.comicsIGot.concat(createOwnershipRecord(card, prevState.currentSeries.id, prevState.currentCard.id ? prevState.currentCard.id : 0)) }
        ), this.updateIGotStatus(card, !card.gotIt));
      }

    } else {
      this.setState({ currentComic: card });
    }
  };

  toggleComicOwnership = (card) => {
    // Toggle ownership status for a comic (used in dialog)
    if (isComicOwned(card, this.state.comicsIGot)) {
      this.setState(prevState => (
        { comicsIGot: filterOutOwnedComic(prevState.comicsIGot, card) }
      ), () => this.updateIGotStatus(card, false));
    } else {
      this.setState(prevState => (
        { comicsIGot: prevState.comicsIGot.concat(createOwnershipRecord(card, prevState.currentSeries.id, prevState.currentCard.id ? prevState.currentCard.id : 0)) }
      ), () => this.updateIGotStatus(card, true));
    }
  };

  toggleEditMode = () => {
    this.setState(prevState => ({
      editMode: !prevState.editMode
    }), this.setState({ currentComic: null }))
  };
  setUser = (user) => {
    this.setState({ appuser: user });

    var userData = doc(firestore, "users/" + user.email);
    setDoc(userData,
      { email: user.email }
    );

    var docRef = collection(firestore, "users/" + user.email + "/heroes/");
    onSnapshot(docRef, (querySnapshot) => {
      this.setState({
        cards: []
      });
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        const heroData = doc.data().data;

        // Ensure hero has all required fields when loading
        const enhancedHero = {
          ...heroData,
          publisher: heroData.publisher || 'Unknown',
          resourceURI: heroData.resourceURI || '',
          series: heroData.series || { available: 0, items: [] },
          stories: heroData.stories || { available: 0, items: [] },
          urls: heroData.urls || [],
          resourceType: heroData.resourceType || 'character', // Explicitly preserve resourceType with default
          locked: heroData.locked || false // Explicitly preserve locked flag
        };

        this.setState(prevState => ({
          cards: prevState.cards.concat(enhancedHero)
        }));
      });

    });

    var comicRef = collection(firestore, "users/" + user.email + "/comics/");
    onSnapshot(comicRef, (querySnapshot) => {
      const comicsIGot = querySnapshot.docs.map((doc) => doc.data());
      this.setState({ comicsIGot });
    });
  };

  loadGapIssues = async () => {
    try {
      const gapComics = await loadGapIssuesForUser(this.state.appuser.email, this.state.comicsIGot);
      this.setState({ gapIssues: gapComics });
    } catch (error) {
      console.error("Error loading gap issues:", error);
      alert("Error loading gap issues. Please try again.");
    }
  };

  handleLogout = () => {
    signOut(auth).then(() => {
      console.log('User signed out');
      // onAuthStateChanged listener will handle updating state
    }).catch((error) => {
      console.error('Error signing out:', error);
      alert('Error signing out. Please try again.');
    });
  };

  handleNewReleasesCacheUpdate = (cache) => {
    this.setState({ newReleasesCache: cache });
  };

  render() {
    return (
      <div>
        <Router>
          <ContainedButtons
            showSeries={this.state.series.length}
            showComics={this.state.comics.length}
            toggleEditMode={this.toggleEditMode}
            editMode={this.state.editMode}
            loadGapIssues={this.loadGapIssues}
            appuser={this.state.appuser}
            onLogout={this.handleLogout}
          />
          {this.state.stuffHappening && <CircularProgress />}

          {!this.state.appuser && <AuthDiv />}

          {this.state.appuser && (
            <>
              <Route path="/" exact
                render={(props) => <Queryhero cards={this.state.cards} addNewCard={this.addNewCard} setCurrentCard={this.setCurrentCard} setProgress={this.setProgress} addEnabled={this.state.addEnabled}
                  editMode={this.state.editMode} updateHeroImage={this.updateHeroImage} updateHero={this.updateHero} />}
              />
              <Route path="/quickentry/"
                render={(props) => <QuickEntry
                  appuser={this.state.appuser}
                  comicsIGot={this.state.comicsIGot}
                  updateIGotStatus={this.updateIGotStatus}
                  editMode={this.state.editMode}
                  addComics={this.addComics}
                  cards={this.state.cards}
                  setCurrentCard={this.setCurrentCard}
                  setCurrentSeries={this.setCurrentSeries}
                />}
              />
              <Route path="/missing/"
                render={(props) => <MissingIssues
                  missingComics={this.state.gapIssues}
                  cards={this.state.cards}
                  setCurrentCard={this.setCurrentCard}
                  setCurrentSeries={this.setCurrentSeries}
                  updateIGotStatus={this.updateIGotStatus}
                  comicsIGot={this.state.comicsIGot}
                  editMode={this.state.editMode}
                />}
              />
              <Route path="/releases/"
                render={(props) => <NewReleases
                  appuser={this.state.appuser}
                  comicsIGot={this.state.comicsIGot}
                  cards={this.state.cards}
                  addComics={this.addComics}
                  updateIGotStatus={this.updateIGotStatus}
                  cache={this.state.newReleasesCache}
                  onCacheUpdate={this.handleNewReleasesCacheUpdate}
                />}
              />
              {this.state.currentCard !== '' && <Route path="/comicseries/"
                render={(props) => <ComicSeries hero={this.state.currentCard} series={this.state.series} setCurrentSeries={this.setCurrentSeries}
                  addSeries={this.addSeries} longPressSeriesCallback={this.deleteSeries} editMode={this.state.editMode} />}
              />}
              {this.state.currentCard !== '' && <Route path="/series/"
                render={(props) => <Comics comics={this.state.comics} currentSeries={this.state.currentSeries} addAllComics={this.addAllComics} toggleOwnership={this.toggleComicOwnership} updateSeriesImage={this.updateSeriesImage} />}
              />}
              <Route path="*" exact>
                <Redirect to="/" />
              </Route>
            </>
          )}

          <HeroSelectionDialog
            open={this.state.comicVineMatchDialog.open}
            heroes={this.state.comicVineMatchDialog.results}
            onSelect={this.handleComicVineMatchSelect}
            onClose={this.handleComicVineMatchClose}
          />

          {/* Resource Type Selection Dialog */}
          <Dialog
            open={this.state.resourceTypeDialog.open}
            onClose={this.handleResourceTypeDialogClose}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle>
              Select Resource Type for {this.state.resourceTypeDialog.hero?.name}
            </DialogTitle>
            <DialogContent>
              <p>Please select what type of resource this is to help search Comic Vine accurately:</p>
              <FormControl fullWidth style={{ marginTop: '20px' }}>
                <InputLabel id="resource-type-label">Resource Type</InputLabel>
                <Select
                  labelId="resource-type-label"
                  id="resource-type-select"
                  defaultValue="character"
                  onChange={(e) => {
                    this.selectedResourceType = e.target.value;
                  }}
                >
                  <MenuItem value="character">Character</MenuItem>
                  <MenuItem value="team">Team</MenuItem>
                  <MenuItem value="storyarc">Story Arc</MenuItem>
                </Select>
              </FormControl>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleResourceTypeDialogClose} color="default">
                Cancel
              </Button>
              <Button
                onClick={() => this.handleResourceTypeSelect(this.selectedResourceType || 'character')}
                color="primary"
                variant="contained"
              >
                Save and Search
              </Button>
            </DialogActions>
          </Dialog>

          {/* No Results Notification */}
          <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            open={this.state.noResultsSnackbar.open}
            autoHideDuration={4000}
            onClose={this.closeNoResultsSnackbar}
          >
            <SnackbarContent
              style={{ backgroundColor: '#2196f3' }}
              message={
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <InfoIcon style={{ marginRight: '8px' }} />
                  No Comic Vine results found for "{this.state.noResultsSnackbar.name}"
                </span>
              }
              action={
                <IconButton size="small" color="inherit" onClick={this.closeNoResultsSnackbar}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              }
            />
          </Snackbar>
          <SeriesSelectionDialog
            open={this.state.seriesMatchDialog.open}
            seriesList={this.state.seriesMatchDialog.results}
            onSelect={this.handleSeriesMatchSelect}
            onClose={this.handleSeriesMatchClose}
            hasMore={this.state.seriesMatchDialog.hasMore}
            onLoadMore={this.handleSeriesMatchLoadMore}
            totalResults={this.state.seriesMatchDialog.totalResults}
          />

          {/* Duplicate Series Warning Dialog */}
          <Dialog
            open={this.state.duplicateSeriesDialog.open}
            onClose={this.handleDuplicateSeriesCancel}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle>Duplicate Series Found</DialogTitle>
            <DialogContent>
              <p>A series with the same Comic Vine ID already exists in this hero's collection:</p>
              <p><strong>Existing:</strong> {this.state.duplicateSeriesDialog.existingSeries?.title}</p>
              <p><strong>New:</strong> {this.state.duplicateSeriesDialog.newSeries?.title}</p>
              <p style={{ color: '#d32f2f', fontWeight: 'bold' }}>
                ⚠️ Replacing will permanently delete all existing issues and ownership data for this series. This cannot be undone.
              </p>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleDuplicateSeriesCancel}>Cancel</Button>
              <Button onClick={this.handleDuplicateSeriesReplace} color="secondary" variant="contained">
                Replace
              </Button>
            </DialogActions>
          </Dialog>
        </Router>
      </div>
    )
  };
}

export default App;
// ReactDOM.render(<App />, mountNode);
